import FlowbiteInstances from 'flowbite/lib/esm/dom/instances';

import * as Utils from '@js/modules/utils';

import I18n from '@js/modules/translations';

import {userStore} from '@js/stores/userStore';

import {initUser, updateUserUnit} from '@js/actions/userActions';

import AnalyticsService from '@js/modules/analyticsService';

import Notification from '@js/components/layouts/notification';


class UserManager {
    /* Public methods
    ******************** */
    initialize = () => {
        this._initUser();

        this._handleUnitChange();
    };

    /* Private methods
    ******************** */
    _initUser = () => {
        const userId = Utils.getCookie('user.connected_id') || window.currentUserId;

        if (userId) {
            initUser(userId);
        } else {
            userStore.featureFlags = window.features;
        }
    };

    _handleUnitChange = () => {
        const kmButtonElement = document.getElementById('unit-menu-km');
        const miButtonElement = document.getElementById('unit-menu-mi');
        if (!kmButtonElement || !miButtonElement) {
            return;
        }

        kmButtonElement.onclick = (event) => {
            event.preventDefault();

            this._changeUserUnit('km');

            kmButtonElement.classList.toggle('menu-item-current');
            kmButtonElement.classList.toggle('font-bold');

            miButtonElement.classList.toggle('menu-item-current');
            miButtonElement.classList.toggle('font-bold');
        };

        miButtonElement.onclick = (event) => {
            event.preventDefault();

            this._changeUserUnit('mi');

            miButtonElement.classList.toggle('menu-item-current');
            miButtonElement.classList.toggle('font-bold');

            kmButtonElement.classList.toggle('menu-item-current');
            kmButtonElement.classList.toggle('font-bold');
        };
    };

    _changeUserUnit = (newUnit) => {
        const previousUnit = window.unit;

        window.unit = newUnit;

        updateUserUnit(newUnit)
            .then(() => {
                // Only once saved: a request alongside it writes back the visitor's session without the unit.
                // Manual override signals the auto-detected unit was wrong for this visitor.
                AnalyticsService.trackUnitManualOverride(previousUnit, newUnit);

                // Hide the header's own instance (a new one would leave it counted as an open menu).
                FlowbiteInstances.getInstance('Dropdown', 'language-dropdown-menu')?.hide();

                const unitMenuElement = document.getElementById('unit-menu-display');
                if (unitMenuElement) {
                    unitMenuElement.textContent = newUnit;
                }

                userStore.unit = newUnit;

                if (window.location.pathname === '/' || window.location.pathname === '/explore') {
                    // Server-rendered ride cards are not bound to the store: reformat them in place.
                    if (document.querySelector('[data-ride-metric]')) {
                        import('@js/modules/rideCardMetrics').then(({refreshRideCardMetrics}) => refreshRideCardMetrics(newUnit));
                    }

                    Notification.success(I18n.t('js.views.header.units.updated', {unit: newUnit}));
                } else {
                    Utils.forcePageReload(window.location);
                }
            });
    };
}

export default new UserManager();
